import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { AppInitService } from '../services/app-init.service';
import { AuthenticationService } from '../services/authentication.service';
import { AuthType } from '../constants/digigov.constants';

@Injectable()
export class AuthGuardService implements CanActivate {
  isAuthenticated = true;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private appInitService: AppInitService,
    //OIDC
    private oauthService: OAuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      return true;
    }
    if (this.appInitService?.appConfig?.authType === AuthType.OATUH2) {
      if (this.oauthService.hasValidAccessToken()) {
        return true;
      } else {
        const originalUrl = state.url.includes('login')
          ? this.appInitService.appConfig.afterLoginLandingUrl
          : state.url;
        const oauthState = {
          originalUrl: originalUrl,
        };
        this.appInitService.loginWithOIDC(JSON.stringify(oauthState));
        return false;
      }
    }

    if (
      this.appInitService?.appConfig?.authType != AuthType.JWT &&
      this.appInitService?.appConfig?.authType != AuthType.COOKIE &&
      this.appInitService?.appConfig?.authType != AuthType.OATUH2
    ) {
      //Bypass all URLs for Develeopement Environment
      return true;
    }
    if (this.appInitService?.appConfig?.dev) {
      //Bypass all URLs for Develeopement Environment
      return true;
    }
    if (
      this.appInitService?.appConfig?.authType !== AuthType.OATUH2 &&
      state.url.includes('login')
    ) {
      return true;
    }
    void this.router.navigate(['login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
